import React, { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import useGlobalModel from "@/model/globalModel";
import { IAcctUnitDetail, IAcctUnitSearchFields, acctUnitService, IAcctUnitFormFields, IAcctUnitInsert, IAcctUnitUpdate } from "./acctUnitService";
import { globalPrompt } from "@/components/YhMessage";
import { transPgToPagination } from "@/utils/utils";


export const useAcctUnitModel = createModel(function () {
    const { user: { shopId, shopName, userName } } = useGlobalModel();
    //列表数据源
    const [dataSource, setDataSource] = useState<IAcctUnitDetail[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    //查询条件
    const [searchParam, setSearchParam] = useState<IAcctUnitSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IAcctUnitDetail[]>([]);
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IAcctUnitSearchFields = searchParam) => {
        setLoading(true);
        const searchParams = {
            shopId,
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await acctUnitService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IAcctUnitSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //切换门店重置缓存
    useEffect(() => {
        setSearchParam({});
        setSelectedRowKeys([]);
        setAddFormVal({ ...initAddFormVal, shopName, createUser: userName });
    }, [shopId]);

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /** 
     * 表单详情
     */

    const initAddFormVal = {
        createUser: userName,
        status: true
    }
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<object>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<object>(initAddFormVal);
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initAddFormVal);
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getAcctUnitOne = async (code: string) => {
        let { retData } = await acctUnitService.one({ code });
        retData && setEditFormVal({
            ...retData,
            status: !!retData.status,
            bentity: retData.bentity?.split(',')
        });
    }
    //启用 禁用 api
    const disableAcctUnit = async (code: string, status: number) => {
        let { retData } = await acctUnitService.disable({ code, status });
        retData ?
            loadData() && globalPrompt("message", { text: "操作成功", type: "success" })
            : globalPrompt("message", { text: "操作失败", type: "error" });
    };
    //表单新增 Api
    const insertAcctUnit = async (val: IAcctUnitFormFields) => {
        let { retData } = await acctUnitService.insert({ ...val, createUser: userName, });
        retData ?
            globalPrompt("message", { text: "新增成功", type: "success" })
            : globalPrompt("message", { text: "新增失败", type: "error" });
        return retData;
    }

    //表单编辑 Api
    const editAcctUnit = async (val: IAcctUnitFormFields) => {
        let { retData } = await acctUnitService.update(val);
        retData ?
            loadData() && globalPrompt("message", { text: "编辑成功", type: "success" })
            : globalPrompt("message", { text: "编辑失败", type: "error" });
        return retData;
    }


    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addFormVal,
        loading,
        /***method***/
        updateAddFormVal,
        updateEditFormVal,
        insertAcctUnit,
        editAcctUnit,
        getAcctUnitOne,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        disableAcctUnit
    }
});